/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowRoundTimeForwardIcon20Solid = forwardRef('ArrowRoundTimeForwardIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M12.316 4.197a6.249 6.249 0 1 0 3.393 8.345 1 1 0 0 1 1.827.813A8.248 8.248 0 1 1 16 4.34V3a1 1 0 1 1 2 0v4a1 1 0 0 1-1 1h-4a1 1 0 1 1 0-2h1.8a6.249 6.249 0 0 0-2.484-1.803Z" })));
});
